import { useCallback, useRef } from "react"

/**
 * Hook to debounce a funciton
 * @param {number} timeout The number on MS to debounce
 * @param {function} toInvoke the function to invoke
 * @param {function} [onFirst] to be invoked on the first interaction
 *
 * @returns the debounced funciton
 */
export function useDebounce(timeout, toInvoke, onFirst) {
  const timeoutRef = useRef()
  const firstRef = useRef()
  return useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      if (onFirst && !firstRef.current) {
        firstRef.current = true
        onFirst()
      }
      if (timeout === 0) {
        toInvoke.call(null, ...args)
        return
      }
      timeoutRef.current = setTimeout(() => {
        toInvoke.call(null, ...args)
        firstRef.current = null
      }, timeout)
    },
    [timeout, toInvoke, onFirst],
  )
}
